import { useTheme } from './ThemeContext';

export const NODE_PALETTE = {
  dark:  ['#ef4444', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#06b6d4', '#f97316', '#ec4899', '#84cc16', '#6366f1'],
  light: ['#dc2626', '#2563eb', '#059669', '#b45309', '#7c3aed', '#0891b2', '#c2410c', '#be185d', '#4d7c0f', '#4338ca'],
};

export const LINK_PALETTE = {
  dark:  ['#1d4ed8', '#dc2626', '#047857', '#d97706', '#7c3aed', '#0891b2', '#db2777', '#65a30d', '#ea580c', '#4f46e5'],
  light: ['#1e40af', '#991b1b', '#065f46', '#92400e', '#6d28d9', '#155e75', '#9d174d', '#3f6212', '#9a3412', '#3730a3'],
};

export const CHART_PALETTE = {
  dark:  ['#d4a574', '#86efac', '#93c5fd', '#f87171', '#c4b5fd', '#fbbf24', '#34d399', '#60a5fa'],
  light: ['#8a6a2d', '#047857', '#1e40af', '#b91c1c', '#6d28d9', '#b45309', '#065f46', '#1e3a8a'],
};

export const STRUCTURE_COLORS_BY_MODE = {
  dark: {
    nodeType: '#3b82f6',
    predicate: '#10b981',
    namespace: '#f59e0b',
    person: '#ef4444',
    grave: '#06b6d4',
    document: '#8b5cf6',
    relationship: '#64748b',
    birth: '#f59e0b',
    death: '#7c2d12',
    nationality: '#3b82f6',
    occupation: '#8b5cf6',
    location: '#06b6d4',
    coordinates: '#0891b2',
    name: '#10b981',
    general: '#64748b',
  },
  light: {
    nodeType: '#2563eb',
    predicate: '#059669',
    namespace: '#b45309',
    person: '#dc2626',
    grave: '#0891b2',
    document: '#7c3aed',
    relationship: '#475569',
    birth: '#b45309',
    death: '#7c2d12',
    nationality: '#2563eb',
    occupation: '#7c3aed',
    location: '#0891b2',
    coordinates: '#155e75',
    name: '#059669',
    general: '#475569',
  },
};

export const useDataVizPalette = (kind = 'node') => {
  const { theme } = useTheme();
  const map = {
    node: NODE_PALETTE,
    link: LINK_PALETTE,
    chart: CHART_PALETTE,
  };
  const palette = map[kind] || NODE_PALETTE;
  return palette[theme] || palette.dark;
};

export const useStructureColors = () => {
  const { theme } = useTheme();
  return STRUCTURE_COLORS_BY_MODE[theme] || STRUCTURE_COLORS_BY_MODE.dark;
};

export const getStructureColorsByMode = (mode) =>
  STRUCTURE_COLORS_BY_MODE[mode] || STRUCTURE_COLORS_BY_MODE.dark;
